import React, { useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { theme as themeConfig } from "../../themes/themes";
import {
  ButtonClean,
  ButtonFilter,
  ContentFilters,
  FieldsContainer,
  FieldContainer,
  DateContainer,
} from "./GeneralFiltersComponent.styled";

const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    margin: "auto 1em",
    width: "100%",
    borderColor: themeConfig.primary.icon,
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: themeConfig.primary.blue,
      boxShadow: "0 0 0 0.2rem rgb(0 123 255 / 25%)",
    },
  }),
};

const GeneralFiltersComponent = ({
  filtersViews,
  languages,
  speakers,
  eventCategories,
  countries,
  cities,
  eventStatus,
  setDataFilter,
  handleChangeSelectCountry,
  handleCleanFilters,
  FilterEvents,
  showTopHR = false,
  rCities,
}) => {
  const rLanguage = useRef();
  const rSpeaker = useRef();
  const rEventCategory = useRef();
  const rInitialDate = useRef();
  const rFinalDate = useRef();
  const rCountries = useRef();
  const rName = useRef();
  const rStatusWellnessAttends = useRef();

  let changeDataFilter = (isClean) => {
    let filter = {};
    if (rLanguage.current?.state?.ariaSelection?.value?.value) {
      filter.language = rLanguage.current.state.ariaSelection.value?.value;
    }
    if (rSpeaker.current?.state?.ariaSelection?.value?.value) {
      filter.speaker = rSpeaker.current.state.ariaSelection.value?.value;
    }
    if (rEventCategory.current?.state?.ariaSelection?.value?.value) {
      filter.eventCategory =
        rEventCategory.current.state.ariaSelection.value?.value;
    }
    if (rInitialDate.current?.value) {
      filter.initialDate = new Date(rInitialDate.current.value).toJSON();
    }
    if (rFinalDate.current?.value) {
      filter.finalDate = new Date(
        new Date(rFinalDate.current?.value).setUTCHours(23, 59, 59)
      ).toJSON();
    }
    if (rCountries.current?.state?.selectValue[0]?.value) {
      filter.country = rCountries.current.state.selectValue[0].value;
    }
    if (rCities.current?.state?.selectValue[0]?.value) {
      filter.city = rCities.current.state.selectValue[0].value;
    }
    if (rName.current?.value) {
      filter.name = rName.current.value;
    }
    if (rStatusWellnessAttends.current?.state?.ariaSelection?.value?.value) {
      filter.status =
        rStatusWellnessAttends.current.state.ariaSelection.value?.value;
    }
    setDataFilter(filter);
  };

  let cleanFilters = () => {
    if (rLanguage.current) {
      rLanguage.current.state.ariaSelection = [];
      rLanguage.current.clearValue();
    }
    if (rSpeaker.current) {
      rSpeaker.current.state.ariaSelection = [];
      rSpeaker.current.clearValue();
    }
    if (rEventCategory.current) {
      rEventCategory.current.state.ariaSelection = [];
      rEventCategory.current.clearValue();
    }
    if (rInitialDate.current) rInitialDate.current.value = null;
    if (rFinalDate.current) rFinalDate.current.value = null;
    if (rCities.current) {
      rCities.current.state.ariaSelection = [];
      rCities.current.clearValue();
    }
    if (rCountries.current) {
      rCountries.current.state.ariaSelection = [];
      rCountries.current.clearValue();
    }
    if (rStatusWellnessAttends.current) {
      rStatusWellnessAttends.current.state.ariaSelection = [];
      rStatusWellnessAttends.current.clearValue();
    }
    if (rInitialDate.current) rInitialDate.current.value = new Date();
    if (rFinalDate.current) rFinalDate.current.value = new Date();
    if (rName.current) rName.current.value = "";
    changeDataFilter(true);
    handleCleanFilters();
  };

  useEffect(() => {
    if (rInitialDate.current) rInitialDate.current.value = new Date();
    if (rFinalDate.current) rFinalDate.current.value = new Date();
  }, []);

  return (
    <FieldsContainer>
      {filtersViews?.search.show && (
        <>
          <FieldContainer>
            <Form.Control
              type="text"
              ref={rName}
              placeholder={filtersViews.search.label}
              onBlur={() => changeDataFilter()}
            />
          </FieldContainer>
        </>
      )}
      {filtersViews?.countries && (
        <FieldContainer>
          <Select
            styles={customStyles}
            placeholder="Country"
            ref={rCountries}
            options={countries}
            onChange={(e) => {
              rCities.current.state.ariaSelection = [];
              handleChangeSelectCountry(e);
            }}
            onBlur={() => changeDataFilter()}
          />
        </FieldContainer>
      )}
      {filtersViews?.countries && filtersViews?.cities && (
        <FieldContainer>
          <Select
            styles={customStyles}
            placeholder="City"
            ref={rCities}
            options={cities}
            onBlur={() => changeDataFilter()}
          />
        </FieldContainer>
      )}
      {filtersViews?.languages && (
        <FieldContainer>
          <Select
            styles={customStyles}
            placeholder="Language"
            ref={rLanguage}
            options={languages}
            onBlur={() => changeDataFilter()}
          />
        </FieldContainer>
      )}
      {filtersViews?.speakers && (
        <FieldContainer>
          <Select
            styles={customStyles}
            placeholder="Speaker"
            ref={rSpeaker}
            options={speakers}
            onBlur={() => changeDataFilter()}
          />
        </FieldContainer>
      )}
      {filtersViews?.eventCategories && (
        <FieldContainer>
          <Select
            styles={customStyles}
            placeholder="Category"
            ref={rEventCategory}
            options={eventCategories}
            onBlur={() => changeDataFilter()}
          />
        </FieldContainer>
      )}
      {filtersViews?.status && (
        <FieldContainer>
          <Select
            styles={customStyles}
            placeholder="status"
            ref={rStatusWellnessAttends}
            options={eventStatus}
            onBlur={() => changeDataFilter()}
          />
        </FieldContainer>
      )}
      {filtersViews.initialDate && (
        <DateContainer>
          <Form.Control
            type="date"
            required={false}
            ref={rInitialDate}
            onBlur={() => changeDataFilter()}
          />
          <Form.Control
            type="date"
            required={false}
            ref={rFinalDate}
            onBlur={() => changeDataFilter()}
          />
        </DateContainer>
      )}
      <ContentFilters>
        <ButtonClean onClick={() => cleanFilters()}>Reset</ButtonClean>
        <ButtonFilter onClick={() => FilterEvents()}>Apply</ButtonFilter>
      </ContentFilters>
    </FieldsContainer>
  );
};
export default GeneralFiltersComponent;
